import React from 'react'; 
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { RootState, useAppDispatch, useAppSelector } from "../../../state/state.tsx";
import { Checkbox, CircularProgress, FormControlLabel, IconButton, InputAdornment, TextField } from '@mui/material';
import { closeModal } from '../../../state/ModalSlice/ModalSlice.ts';
import CloseIcon from "@mui/icons-material/Close";
import { useBackend } from '../../../hooks/backend/useBackend.ts';
import { db, SECRETS_ENV } from '../../../Config/firebase.ts';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { getFutureCycles } from '../utilityFunctions.ts';
import { doc, getDoc, Timestamp } from 'firebase/firestore';
import { selectEffectiveUID } from '../../../state/UserStatesV2/userSliceV2.ts';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const secretCloudTaskToken = import.meta.env.VITE_SECRET_CLOUD_TASK_TOKEN || process.env.VITE_SECRET_CLOUD_TASK_TOKEN

export default function ResumeLiveSubscriptionModal() {

    const Dispatch = useAppDispatch();
    const isLoading = useAppSelector((state: RootState) => state.ModalSlice.isLoading)
    const open = useAppSelector((state: RootState) => state.ModalSlice.ResumeLiveSubscriptionModalOpen)
    const ServiceProviderID: string = useAppSelector(selectEffectiveUID) 
    const { LiveSubscriptionId, chargeNowVisible } = useAppSelector((state: RootState) => state.ArbitrarySlice.ForResumeLiveSubscriptionModal)

    // States
    const [chargeNow, setChargeNow] = useState<boolean>(true)
    const [chargeNowPrice, setChargeNowPrice] = useState<string>("0")
    const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false)
    const [isCancelLoading, setIsCancelLoading] = useState<boolean>(false)

    // Reset States
    const resetStates = () => {
        setChargeNow(true)
        setChargeNowPrice("0")
        setIsConfirmLoading(false)
        setIsCancelLoading(false)
    }

    // HandleChange Functions̥

    async function handleClose() {
        setIsCancelLoading(true)
        resetStates()
        Dispatch(closeModal("ResumeLiveSubscriptionModalOpen"))
        setIsCancelLoading(false)
    }

    const handleChangeChargeNow = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChargeNow(event.target.checked)
    }

    const handleChangeChargeNowPrice = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        // -------------Function to handle only decimal and number inputs
        if (!value) {
            setChargeNowPrice("")
            return;
        }
        let decimalCount = 0;
        for (let i = 0; i < value.length; i++) {
            const char = value[i];
            if (char >= '0' && char <= '9') { /* empty */
            } else if (char === '.') {
                if (decimalCount === 0) {
                    decimalCount++;
                } else {
                    return;
                }
            } else {
                return;
            }
        }
        setChargeNowPrice(value)
    }


    // On Submit operation

    const { axiosPostRequest } = useBackend("")

    const { update } = useBackend(`/ServiceProviders/${ServiceProviderID}/LiveSubscriptions`)


    async function handleQuickAddAPICall() {
        
        const body = {
            providerId: ServiceProviderID,
            livesubscriptionId: LiveSubscriptionId,
            orderType: "online",
            chargeable: Number(chargeNowPrice),
            recurring: false,
            cycleName: getFutureCycles()[0],
            secretCloudTaskToken: secretCloudTaskToken
        }
        try {
            const response = await axiosPostRequest(`${SECRETS_ENV.API_END_POINT}/api/quickOrder`, body)
            if (response.message !== "Request successful") {
               
                return "error"
            }
        } catch (error) {
            
            return "error"
        }

       
        return "success"
    }

    async function onSubmit() {
        setIsConfirmLoading(true)
        try {
            // Update LiveSubscription status to Active and add resumeTS to the last pauseHistory entry
            const docRef = doc(db, `ServiceProviders/${ServiceProviderID}/LiveSubscriptions`, LiveSubscriptionId);
            const docSnap = await getDoc(docRef);
            

            // If chargeNow is true and chargeNowPrice is not empty or zero, call handleQuickAddAPICall
            if (chargeNow && chargeNowPrice !== "" && Number(chargeNowPrice) > 0) {
                const result = await handleQuickAddAPICall();
                if (result === "error") {
                    throw new Error("Failed to charge subscriber");
                }
            }
            if (docSnap.exists()) {
                const data = docSnap.data();
                const pauseHistory = data.pauseHistory || [];
                
                if (pauseHistory.length > 0) {
                    const updatedPauseHistory = [...pauseHistory];
                    updatedPauseHistory[updatedPauseHistory.length - 1].resumeTS = Timestamp.now();

                    await update(LiveSubscriptionId, { 
                        status: "Active",
                        pauseHistory: updatedPauseHistory,
                        updatedAt: Timestamp.fromDate(new Date())
                    });
                } else {
                    const updatedPauseHistory = [{  
                        resumeTS: Timestamp.now()
                    }]
                    await update(LiveSubscriptionId, { 
                        status: "Active",
                        pauseHistory: updatedPauseHistory
                    });
                }
            }

            toast.success("Student resumed successfully");
        } catch (error) {
            toast.error("Failed to resume student");
        }

        setIsConfirmLoading(false)
        handleClose()
    }


    return (
        <Dialog
            sx={{
                padding: 0,
                '& .MuiPaper-root': {
                    borderRadius: '10px',
                },

            }}
            maxWidth="md"
            open={open }
            disableEscapeKeyDown
            PaperProps={{
                component: 'div',
            }}
        >
            <DialogContent sx={{ paddingX: "60px", paddingY: "40px" }} className={"bg-white"}>
                <div className={"header pb-[20px] min-w-[550px]"}>
                    <p className={"text-cf_heading font-[600] "}>Resume Student</p>
                </div>

                <div className={"absolute right-4 top-4"}><IconButton onClick={handleClose}>
                    <CloseIcon />
                </IconButton></div>

                <div className={"pt-0"}>
                    <p>Student is paused. Do you want to resume the student? Confirming will resume the subscription and the subscriber will be able to access the services and Invoices again .</p>
                </div>

               {chargeNowVisible && <div className={"flex flex-col gap-4 mt-4 font-semibold"}>
                    <div>
                        <p>Do you want to charge the student?</p>
                    </div>
                    <div className={"flex gap-4 w-[370px]"}>
                                        <div className={""}>
                                            <FormControlLabel
                                                control={<Checkbox checked={chargeNow} onChange={handleChangeChargeNow}/>}
                                                label="Charge Now?"
                                                sx={{
                                                    '& .MuiFormControlLabel-label': {
                                                        fontSize: '14px', // Setting the font size for the label
                                                    }
                                                }}
                                            />
                                        </div>


                                        {chargeNow && <TextField
                                            value={chargeNowPrice}
                                            size="small"
                                            id="ChargeablePrice"
                                            label="Chargeable (Min ₹6)"
                                            onChange={handleChangeChargeNowPrice}
                                            variant="outlined"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">₹</InputAdornment>,

                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px'// Default border color
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey', // Border color on hover
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue', // Border color when focused
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px', // Setting font size
                                                    },
                                                },
                                                fontWeight: 400,
                                                maxWidth: 250
                                            }}


                                        />}
                                    </div>

                </div>}

                <div className={"flex gap-2 pt-8"}>
                    <button onClick={handleClose} disabled={isCancelLoading || isConfirmLoading}
                        className={`w-full bg-cc_bg-tertiary border border-solid border-gray-500 p-1.5 rounded-lg ${(isCancelLoading || isConfirmLoading) ? "cursor-not-allowed" : "cursor-pointer"}`}>
                        {isCancelLoading && <CircularProgress sx={{ color: "gray" }} size={20} />}
                        <p className={"ml-2"}>{isCancelLoading ? "Loading" : "Cancel"}</p>
                    </button>
                    <button
                        onClick={onSubmit} disabled={isConfirmLoading || isCancelLoading}
                        className={`w-full bg-cc_brand text-white p-1.5 rounded-lg border-gray-500 flex justify-center items-center ${(isConfirmLoading || isCancelLoading) ? "cursor-not-allowed" : "cursor-pointer"}`}>
                        {isConfirmLoading && <CircularProgress sx={{ color: "white" }} size={20} />}
                        <p className={"ml-2"}>{isConfirmLoading ? "Loading" : "Confirm"}</p>
                    </button>
                </div>
            </DialogContent>
        </Dialog>
    );
}